import React from "react";
import { Box, Paper, TextField, Typography, Checkbox, Dialog } from "@mui/material";
import WrappedButton from "./WrappedButton";
import { getQueryParam } from "./FormScripts";

interface LoginProps {
	onClose: Function;
}

export default function LoginModal(props: LoginProps) {
	const [user, setUser] = React.useState("");
	const [pass, setPass] = React.useState("");
	const [isSaving, setSaving] = React.useState(false);
	const [hasError, setHasError] = React.useState(false);
	const [useAd, setUseAd] = React.useState(false);
	const [loggedOut, setLoggedOut] = React.useState(false);
	const errMsg = getQueryParam("login_error");

	const [useSso, setUseSso] = React.useState(false);

	const checkKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if ((event as any).which === 13) {
			login();
		}
	};
	React.useEffect(() => {
		fetch("login/UseSSO")
			.then((dt) => dt.json())
			.then((dt) => {
				if (dt) {
					setUseSso(true);
				}
			});
			
			fetch("login/Logout").then(() => {
				setLoggedOut(true);
			})
		// eslint-disable-next-line
	}, []);

    /**
     * Initiates SSO login in a popup window.
     * Handles communication from SSO callback via postMessage.
     */
    const sso = () => {
        const ssoUrl = `/login/login?user=${encodeURIComponent(user)}&isSessionExpired=true`;
        const width = 600, height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        const popup = window.open(
            ssoUrl,
            'SSOLogin',
            `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`
        );

        if (!popup) {
            setHasError(true);
            alert('Popup blocked! Please allow popups for this site.');
            return;
        }

        setSaving(true); // Show loading

        // Handler for messages from popup
        const handleMessage = (event: MessageEvent) => {
            // TODO: Optionally check event.origin for security
            if (event.data && event.data.ssoAuth) {
                // SSO success
                setSaving(false);
                props.onClose(true); // Close modal, signal success
                window.removeEventListener('message', handleMessage);
                popup.close();
            } else if (event.data && event.data.ssoError) {
                setSaving(false);
                setHasError(true);
                window.removeEventListener('message', handleMessage);
                popup.close();
            }
        };

        window.addEventListener('message', handleMessage);

        // Fallback: detect if popup is closed before login
        const popupInterval = setInterval(() => {
            if (popup.closed) {
                setSaving(false);
                window.removeEventListener('message', handleMessage);
                clearInterval(popupInterval);
            }
        }, 500);
    };

	const login = async () => {
		setSaving(true);
		let dt: any = await fetch("login/Authenticate", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ username: user, password: pass, tzo: -(new Date("1/1/2009").getTimezoneOffset() / 60), useAd: useAd, isSessionExpired: true }),
		});
		if (dt.ok) {
			var res = await dt.json();
			if (res) {
				props.onClose(true);
				// history.push("/mainmenu");
			} else {
				setHasError(true);
			}
		} else {
			setHasError(true);
		}
		setSaving(false);
	};

    return (
        <Dialog open={true} fullScreen onClose={() => props.onClose(false)}>
			{!loggedOut ? (<></>) : 
            <Box sx={{ height: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", backgroundImage: "url('auth-background.jpg')", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundColor: "background.default" }}>
                <Paper sx={{ p: 2, flexDirection: "column", display: "flex" }}>
                    <img style={{ maxWidth: "250px", marginBottom: "16px" }} src="logo-2.png" alt=""></img>
                    <TextField
                        label="Username"
                        variant="outlined"
                        value={user}
                        onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => checkKeyUp(event)}
                        sx={{ marginBottom: 2 }}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setUser(event.target.value);
                        }}></TextField>
                    <TextField
                        label="Password"
					type="password"
					variant="outlined"
					value={pass}
					onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => checkKeyUp(event)}
					// className={props.classes.loginInput}
					sx={{ marginBottom: 2 }}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						setPass(event.target.value);
					}}></TextField>
				<Typography variant="body1" color={"error"} hidden={!hasError && !errMsg}>
					{errMsg ?? "Invalid username or password."}
				</Typography>
				<Typography style={{ textAlign: "start" }} variant="body2">
					Use Active Directory?
				</Typography>
				<Checkbox style={{ width: "0%", padding: "0px 10px 5px" }} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUseAd(event.target.checked)}></Checkbox>
				<Box sx={{ display: "flex" }}>
					{useSso && <WrappedButton isBusy={isSaving} caption={"SSO Login"} onClick={sso}></WrappedButton>}
					<WrappedButton isBusy={isSaving} caption="Evolv Login" onClick={login}></WrappedButton>
				</Box>
			</Paper>
			<Typography variant="body1" sx={{ fontSize: "12px", fontWeight: 600, position: "absolute", bottom: 0 }}>
				Powered By Ilmir, Inc.
			</Typography>
		</Box>
}
		</Dialog>
	);
}
